<template>
  <div>
    <base-header class="pb-6"> </base-header>
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header border-0">
          <h3 class="mt-4 mb-4 title-2 bold">{{ texts.SCREEN_TITLE }}</h3>
        </div>
        <div class="row starter-page">
          <div class="container-fluid">
            <delivery-connection-notice
              v-if="showConnectionNotice"
              :last-update="lastUpdate"
              :session-expired="sessionExpired"
              @login-requested="goToLogin"
            />
            <p v-if="initialLoading" class="col-12 text-muted">{{ texts.LOADING }}</p>
            <p v-else-if="showLoadError" class="col-12 text-danger">{{ texts.ERROR }}</p>
            <p v-else-if="!routes.length && !refreshFailed" class="col-12 text-muted">{{ texts.EMPTY }}</p>
            <template v-else-if="routes.length">
              <delivery-summary :routes="routes" />
              <dealer-wait-table :routes="sortedRoutes" :server-now="serverNow" />
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DeliveryGateway from '@/gateways/DeliveryGateway'
import DealerWaitTable from './components/DealerWaitTable.vue'
import DeliveryConnectionNotice from './components/DeliveryConnectionNotice.vue'
import DeliverySummary from './components/DeliverySummary.vue'
import { closeKitchenWaitAudio } from '@/utils/kitchenWaitAudio'
import { sortRoutesByUrgency } from '@/utils/routeUrgency'
import { DELIVERY_TEXTS, HTTP_UNAUTHORIZED, LOGIN_ROUTE_NAME } from './deliveryConstants'
import { REFRESH_INTERVAL_MS } from './kitchenWaitConstants'

export default {
  name: 'Delivery',
  components: {
    DealerWaitTable,
    DeliveryConnectionNotice,
    DeliverySummary
  },
  data () {
    return {
      routes: [],
      serverNow: new Date().toISOString(),
      initialLoading: true,
      refreshFailed: false,
      sessionExpired: false,
      lastUpdate: '',
      refresh: null
    }
  },
  computed: {
    texts () {
      return DELIVERY_TEXTS
    },
    sortedRoutes () {
      return sortRoutesByUrgency(this.routes)
    },
    showConnectionNotice () {
      return this.refreshFailed && (this.routes.length > 0 || this.sessionExpired)
    },
    showLoadError () {
      return this.refreshFailed && !this.routes.length && !this.sessionExpired
    }
  },
  created () {
    this.fetchRoutes()
    this.refresh = setInterval(this.fetchRoutes, REFRESH_INTERVAL_MS)
  },
  beforeDestroy () {
    if (this.refresh) {
      clearInterval(this.refresh)
      this.refresh = null
    }
    closeKitchenWaitAudio()
  },
  methods: {
    fetchRoutes () {
      DeliveryGateway
        .dealerWait()
        .then((response) => this.applyRoutes(response))
        .catch((error) => this.applyRoutesError(error))
        .finally(() => { this.initialLoading = false })
    },
    applyRoutes (response) {
      this.routes = response.data.routes || []
      this.serverNow = response.data.server_now
      this.lastUpdate = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
      this.refreshFailed = false
      this.sessionExpired = false
    },
    applyRoutesError (error) {
      console.error('Failed to load dealer wait routes', error)
      this.refreshFailed = true
      this.sessionExpired = Boolean(error.response) && error.response.status === HTTP_UNAUTHORIZED
    },
    goToLogin () {
      this.$router.push({ name: LOGIN_ROUTE_NAME })
    }
  }
}
</script>
